import { storage }  from '../utils'
import Base64 from '../utils/base64'

export const getB3BillingAddressExtras = () => {
  let B3BillingAddressExtras = storage.B3BillingAddressExtras.getValue()

  B3BillingAddressExtras = B3BillingAddressExtras ? JSON.parse(B3BillingAddressExtras) : []
 
  return B3BillingAddressExtras
}

export const getB3ShippingAddressExtras = () => {
  let B3ShippingAddressExtras = storage.B3ShippingAddressExtras.getValue()

  B3ShippingAddressExtras = B3ShippingAddressExtras ? JSON.parse(B3ShippingAddressExtras) : []
 
  return B3ShippingAddressExtras
}

// TODO: vaild extras address
// export const isSubmitExtrasFiledsValid = (b2bCustomFields: any, type: string | undefined) => {
//   const B3AddressExtras = type === 'shipping' ? getB3ShippingAddressExtras() : getB3BillingAddressExtras()
//   if (!B3AddressExtras.length) return true
//   let flag: any = false
//   Object.keys(b2bCustomFields).map((item: any) => {
//     const list = B3AddressExtras.find((v: any) => v.name === item)
//     if (list.val !== b2bCustomFields[item]) {
//       flag = true
//     }
//   })
//   return true
// }

export const getDefaultB3AddressExtrasVal = (flag: any) => {
  const B3AdressExtras = flag ? getB3BillingAddressExtras() : getB3ShippingAddressExtras()

  if (B3AdressExtras.length) {
    const customFields: any = {}

    B3AdressExtras.forEach((item: any) => {
      customFields[item.name] = item?.val || ''
    })

    return customFields
  }

  return ''
}

export const saveExtrasAddress = (address: any, type: string) => {
  const B3AddressExtras = type === 'shipping' ? getB3ShippingAddressExtras() : getB3BillingAddressExtras()

  if (B3AddressExtras.length) {
    B3AddressExtras.forEach((item: any) => {
        item.val = (address )[item.name] || ''
        item.default = (address )[item.name] || ''
    })
    storage[type === 'shipping' ? 'B3ShippingAddressExtras': 'B3BillingAddressExtras'].setValue(JSON.stringify(B3AddressExtras))
  }
}

export const billingSameAsShippingAddress = () => {
  const B3ShippingAddressExtras = getB3ShippingAddressExtras()

  storage.B3BillingAddressExtras.setValue(JSON.stringify(B3ShippingAddressExtras))
}

export const isValidExtrasFiles = (type: string) => {
  const extraFields = type === 'shipping' ? getB3ShippingAddressExtras() : getB3BillingAddressExtras()

  if (!extraFields.length) return true

  let flag = true

  extraFields.forEach((field: any) => {
    if (field.required && !field.val) {
      flag = false
    }
  })

  return flag
}

export const setAddressExtrasFiles = (isB3User: any, address: any, isShipping: any) => {
  if(!isB3User || !address?.extraFields) return false

  if (address.extraFields.length === 0) return false

  const extraFields = isShipping ? getB3ShippingAddressExtras() : getB3BillingAddressExtras()
  let flag = false

  extraFields.forEach((field: any) => {
    const item = address.extraFields.find((extraField: any) => Base64.decode(extraField.fieldName) === Base64.decode(field.name))

    if (item) {
      if (field.required && !item.fieldValue) {
        flag = true
      }

      field.val = item.fieldValue
      field.default = item.fieldValue
    }
  })
  storage[isShipping ? 'B3ShippingAddressExtras': 'B3BillingAddressExtras'].setValue(JSON.stringify(extraFields))
  
  return flag
}

export const setAddressSelectExtrasFiles = (address: any) => {
  const selectExtrasFiles: any = {};

  (address?.extraFields || []).forEach((item: any) => {
    selectExtrasFiles[item.fieldName] = item.fieldValue
  })

  return selectExtrasFiles
}

export const setDefaultAddress = (type: string) => {
  let B3DefaultAddressExtras = storage.B3DefaultAddressExtras.getValue()

  B3DefaultAddressExtras = B3DefaultAddressExtras ? JSON.parse(B3DefaultAddressExtras) : [] 
  storage[type === 'shipping' ? 'B3ShippingAddressExtras': 'B3BillingAddressExtras'].setValue(JSON.stringify(B3DefaultAddressExtras))
}

export const setGoBackEcho = (type: string) => {
  const B3AddressExtras = type === 'shipping' ? getB3ShippingAddressExtras() : getB3BillingAddressExtras()
  const obj:any = {}

  if (!B3AddressExtras.length) return obj
  B3AddressExtras.forEach((item: any) => {
    obj[item.name] = item.val
  })

  return obj
}